
import styled from 'styled-components'

export const CardStyles=styled.div`
    
`;
export const StyledContainer=styled.div`
    width: 97%;
    height: 100%;
    padding: 1rem;
    padding-left: 3rem;
    background-color: white;
    border-radius: 1rem;
    @media(max-width: 768px){
        width: 80%;
        padding-left: 1rem;
    }
`;
export const StyledDetails=styled.div`
    width: 97%;
    border-radius: 0.8rem;
    border: 1px solid lightgray;
    height: 10rem;
    margin-top: 3rem;
    padding: 1rem;


    input{
        width: 98%;
        padding: 0.6rem;
        border: 1px solid lightgray;
        border-radius: 0.3rem;
        margin-top: 0;
        &:hover{
            border: 1px solid #169395;
            cursor: pointer;
         
        }
        
    }
    
    button{
        margin-left: 43.7rem;
        padding:  0.8rem 1rem;
        background-color: #169395;
        color: white;
        border: none;
        cursor: pointer;
        border-radius: 0.3rem;
        margin-top: 0.5rem;
        @media(max-width: 768px){
            margin-left: 20rem;
}
    }
    
`;
export const Styledbox=styled.div`
    width: 97%;
    height: 3rem;
    border: 1px solid lightgray;
    margin-top: 1.5rem;
    border-radius: 0.5rem;
    margin-bottom: 4rem;
`;
